import { createBrowserHistory } from 'history';
import { createStore, applyMiddleware, compose } from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import throttle from 'lodash/throttle';
import thunk from 'redux-thunk';
import rootReducer from '../state-reducers/rootReducer';
import initState from './initState';

import { loadState, saveState } from './localStorage';

const persistedState = loadState();
const history = createBrowserHistory();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const Store = createStore(
  connectRouter(history)(rootReducer),
  persistedState,
  composeEnhancers(applyMiddleware(routerMiddleware(history), thunk))
);

// Save to localStoreage (throttle for performance)
Store.subscribe(
  throttle(() => {
    saveState({
      ...initState,
      saved: Store.getState().saved,
    });
  }, 1000)
);

export const mockStore = createStore(
  connectRouter(history)(rootReducer),
  initState,
  composeEnhancers(applyMiddleware(routerMiddleware(history), thunk))
);

export default Store;



// WEBPACK FOOTER //
// ./src/state-store/store.js